import React from 'react'
import {
  Card,
  Typography,
  Box,
  Stack,
  withStyles,
  CircularProgress,
} from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import { BOOK_A_CALL_URL } from '../../../logic'
import { AUDIENCES } from '../../../data/pricing-json'
import styles from './styles'

const PricingPlanCard = ({
  card,
  index,
  onClickHandler,
  classes,
  loading,
}) => {
  const { subscription, price, caption, lists, action, isAllPlansInclude, savings, isAnnual, featuresLead, audience } = card
  const isEnterprise = audience === AUDIENCES.ENTERPRISE

  if (isAllPlansInclude) {
    return (
      <Box className={classes.allPlansRoot}>
        <Typography className={classes.allPlansCaption}>
          {caption}
        </Typography>
        <Typography className={classes.allPlansTitle}>
          <span className={classes.allPlansTitleHighlight}>All Plans Include</span>
        </Typography>
        <Box className={classes.allPlansGrid}>
          {lists.map(item => (
            <Stack
              key={item.text}
              direction="row"
              alignItems="center"
              spacing={1.5}
              className={classes.allPlansItem}
            >
              <Box className={classes.blueCheckCircle}>
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Box>
              <Typography className={classes.allPlansText}>
                {item.text}
              </Typography>
            </Stack>
          ))}
        </Box>
      </Box>
    )
  }

  return (
    <Card
      className={`${classes.cardRoot} ${isEnterprise ? classes.cardRootEnterprise : ''}`}
      elevation={0}
    >
      <Box>
        <Typography className={classes.cardCaption}>
          {caption}
        </Typography>
        <Typography className={classes.cardSubscription}>
          {subscription}
        </Typography>

        {price !== null ? (
          <Box className={classes.priceRow}>
            <Typography className={classes.dollarSign}>$</Typography>
            <Typography className={classes.priceValue}>{price}</Typography>
            <Typography className={classes.priceMonth}>/month</Typography>
          </Box>
        ) : (
          <Box className={classes.priceRow}>
            <Typography className={classes.letsTalkText}>Let's Talk</Typography>
          </Box>
        )}

        {price !== null && savings ? (
          <Box className={classes.savingsRow}>
            <Typography className={classes.savingsCheck}>&#10003;</Typography>
            <Typography className={classes.savingsText}>
              Save ${savings.toLocaleString()} with Annual Billing
            </Typography>
          </Box>
        ) : price === null ? (
          <Typography
            className={classes.tailoredText}
            style={!isAnnual ? { marginBottom: 40 } : undefined}
          >
            Tailored to your needs
          </Typography>
        ) : null}

        <Box
          className={classes.divider}
          style={price !== null && !savings ? { marginTop: 40 } : undefined}
        />

        {featuresLead && (
          <Typography className={classes.featuresLead}>{featuresLead}</Typography>
        )}

        <Stack component="ul" spacing={2} className={classes.featureList}>
          {lists.map(item => (
            <Stack
              key={item.text}
              component="li"
              direction="row"
              alignItems="flex-start"
              spacing={1.5}
              className={classes.featureItem}
            >
              <Box className={classes.blueCheckCircle} style={{ marginTop: 1 }}>
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Box>
              <Typography className={classes.featureText}>
                {item.text}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Box>

      <CoreButton
        fullWidth
        size="large"
        className={action.isCustom ? classes.demoButton : !action.active ? classes.upgradeButton : undefined}
        variant={action.isCustom || action.active ? 'outlined' : 'contained'}
        color={action.active ? 'secondary' : undefined}
        disabled={action.disabled === true || loading}
        onClick={() => {
          !action.isCustom && onClickHandler()
        }}
        href={action.isCustom ? BOOK_A_CALL_URL : undefined}
        target={action.isCustom ? '_blank' : undefined}
      >
        {loading && action.disabled !== true ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          action.text
        )}
      </CoreButton>
    </Card>
  )
}

export default withStyles(styles)(PricingPlanCard)
